// Shared grid constants + tour-hue helper. Kept in its own module so the cell
// and grid components can both import them without a circular dependency.

export const DAY_W = 64; // px per day column — wide enough for run-level labels
                         // ("Charlestown", "Bloomington") to read at a glance
export const INFO_W = 260; // sticky-left info column width
export const ROW_H = 64; // px per vehicle lane (also the info cell height, so
                         // the sticky-left column stays row-aligned with the lanes)
export const BAND_GAP = 2; // horizontal gap between consecutive run-blocks in a band

/* Accent hue per tour — same FNV-1a → HSL as TourTimeline/EventCalendar so a
   tour's color matches what users already see on those pages. */
const ACCENT_HUE_MIN = 75;
const ACCENT_HUE_MAX = 340;
export const hashHue = (str: string): number => {
  let h = 2166136261;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619) >>> 0;
  }
  return ACCENT_HUE_MIN + (h % (ACCENT_HUE_MAX - ACCENT_HUE_MIN));
};
